import script from "./app-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./app-settings.vue?vue&type=script&setup=true&lang=js"

import "./app-settings.vue?vue&type=style&index=0&id=f320aa58&scoped=true&lang=css"
import "./app-settings.vue?vue&type=style&index=1&id=f320aa58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f320aa58"]])

export default __exports__